// extracted by mini-css-extract-plugin
module.exports =  {"chips":"_0d624b9a27--chips--bv95w","chip":"_0d624b9a27--chip--fMWBK","chips_small":"_0d624b9a27--chips_small--R1ba_"};